import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

interface AdminRouteProps {
  children: React.ReactNode;
}

// Extend User type to include admin properties
interface AdminUser {
  is_admin?: boolean;
  is_superuser?: boolean;
  [key: string]: any;
}

/**
 * Protected route component that only allows admin users
 */
export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading } = useAuth();

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Redirect to dashboard if not admin
  const adminUser = user as AdminUser;
  if (!adminUser.is_admin && !adminUser.is_superuser) {
    return <Navigate to="/app/dashboard" replace />;
  }

  // User is admin, render children
  return <>{children}</>;
}
